// Date helpers that keep "YYYY-MM-DD" strings on the calendar day they
// were authored as, regardless of the viewer's timezone.
//
// JavaScript's `new Date("2026-07-14")` parses as UTC midnight, which shifts
// to the prior calendar day in any negative UTC offset (Central Time, Pacific
// Time, etc.). For township event dates / meeting dates we want the literal
// day shown — so we parse them as LOCAL dates.

export const parseLocalDate = (iso) => {
  if (!iso) return new Date(NaN);
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return new Date(iso);
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
};

export const formatLongDate = (iso) => {
  const d = parseLocalDate(iso);
  if (isNaN(d.getTime())) return iso || "";
  return d.toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
};

export const formatShortDate = (iso) => {
  const d = parseLocalDate(iso);
  if (isNaN(d.getTime())) return iso || "";
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};
